import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class AppointmentModel extends BaseModel {
  static urlPath = "appointments";

  @attr("number") pk;
  @attr("datetime") createdAt;
  @attr("datetime") updatedAt;
  @attr("json") client;
  @attr("json") provider;
  @attr("date") appointmentDate;
  @attr("time") appointmentTime;
  @attr("string") status;
  @attr("string") notes;
  @attr("number") providerType;
  @attr("number") documentCount;
  @attr("array") administeredServices;
  @attr("string") runningTotal;
  @attr("json") case;
}
